import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
const NewCoinSingleItem = ({ data }) => {
    const [livePrice, setLivePrice] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const interval = setInterval(() => {
            fetchData();
        }, 1000);
        return () => clearInterval(interval);
    }, [livePrice, data]);

    const fetchData = async () => {
        if (data?.symbol) {
            fetch(
                `https://new-coin-api.wlffinance.org/api/user/new/coin/price/live/view/${data?._id}?period=1m`,
                {
                    method: "GET",
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    setLivePrice(data.data);
                    if (data.data) {
                        setLivePrice(data?.data);
                        setLoading(false);
                    }
                });
        }
    };
    if (loading) {
        return;
    }
    return (
        <>
            <div className="markets-coin">
                <Link to="#">
                    <div className="markets-coin-left">
                        <div className="markets-coin-image">
                            <LazyLoadImage
                                effect="blur"
                                alt="img"
                                src={`https://api.wlffinance.org/${data?.image}`}
                                className="hot-coin-img"
                            />
                        </div>
                        <div className="markets-coin-name">
                            <h4>{data?.name}</h4>
                        </div>
                    </div>
                    <div className="markets-coin-right">
                        <div className="markets-coin-price">
                            <p>${livePrice?.close}</p>
                        </div>
                    </div>
                </Link>
            </div>
        </>
    );
};

export default NewCoinSingleItem;
